import { Skeleton } from '@/components/ui';
import { BinaryQuestionCardSkeleton } from '../BinaryMarkets/BinaryQuestionCardSkeleton';
import { CategoryTabsSkeleton } from '../CategoryTabs/CategoryTabsSkeleton';

export interface LiveFeedSkeletonProps {
  /** The lobby card grid classes, shared with the loaded feed. */
  gridClassName: string;
}

/**
 * Layout-mirroring loader for the Live page: header strip block, category
 * pills, anchor chips, then two sections of card skeletons — never a spinner.
 */
export function LiveFeedSkeleton({ gridClassName }: LiveFeedSkeletonProps) {
  return (
    <div className="flex w-full flex-col gap-4">
      <Skeleton className="h-14 w-full rounded-2xl" />
      <CategoryTabsSkeleton />
      <div className="flex items-center gap-5 px-1">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-5 w-24 rounded-md" />
        ))}
      </div>
      {Array.from({ length: 2 }).map((_, section) => (
        <div key={section} className="flex flex-col gap-3">
          <Skeleton className="h-6 w-32 rounded-md" />
          <div className={gridClassName}>
            {Array.from({ length: 2 }).map((_, i) => (
              <BinaryQuestionCardSkeleton key={i} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
